import React, { useState, useEffect, useRef } from 'react';
import { getFirestore, collection, query, where, getDocs, doc, updateDoc } from 'firebase/firestore';
import styles from './PlatformAccounts.module.css';
import { useNavigate } from 'react-router-dom';
import backgroundImage from '../assets/background4.jpg'; 
import lottie from 'lottie-web';
import loadingBear from '../assets/loadingBear.json';
import './AccountRegistration.css';


const AccountSearchPage = () => {
  const [input, setInput] = useState('');
  const [results, setResults] = useState([]);
  const [editingAccount, setEditingAccount] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [editingVenta, setEditingVenta] = useState(null);
  const [editVentaForm, setEditVentaForm] = useState({});
  
  // Estados para ventas online
  const [mostrarVentasOnline, setMostrarVentasOnline] = useState(false);
  const [ventasOnline, setVentasOnline] = useState([]);
  const [loadingVentasOnline, setLoadingVentasOnline] = useState(false);
  const [editingVentaOnline, setEditingVentaOnline] = useState(null);
  const [editVentaOnlineForm, setEditVentaOnlineForm] = useState({});
  
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const loadingBearRef = useRef(null);

  const db = getFirestore();

  // Función para manejar la notificación de ventas online
  const handleNotifyVentaOnline = (venta, account) => {
    const phoneNumber = venta.numero;
    if (!phoneNumber) {
      alert('El número de teléfono no está disponible');
      return;
    }
    const message = encodeURIComponent(`
Hola 🐻, por motivos de seguridad, hemos cambiado la contraseña de tu cuenta de streaming. Las nuevas credenciales son: 

🪪 *Código*: \`${venta.codigo}\` 🐻 
*Servicio*: _${venta.plataforma}_ 
*Celular:* ${venta.numero} 
*Correo:* ${account.correo} 
*Contraseña:* ${account.contrasena}
*Perfil:* ${venta.nombrePerfil || 'N/A'} 
*PIN:* ${venta.pinPerfil || 'N/A'} 
*Fecha de Corte:* ${venta.fechaCorteFormatted} 

Si tienes alguna duda, avísame
    `);

    const url = `https://api.whatsapp.com/send?phone=+57${phoneNumber}&text=${message}`;
    window.open(url, '_blank');
  };

  // Función para iniciar la edición de venta online
  const handleEditVentaOnlineClick = (venta) => {
    console.log('Raw fechaCorte from venta online:', venta.fechaCorte);
    setEditingVentaOnline(venta);

    // Formatear fechaCorte para el input date (DD/MM/YYYY -> YYYY-MM-DD)
    let fechaCorteFormatted = '';
    if (venta.fechaCorte) {
      const raw = venta.fechaCorte;
      try {
        // Si viene en formato DD/MM/YYYY
        if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(raw)) {
          const [day, month, year] = raw.split('/');
          fechaCorteFormatted = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        }
        // Si ya viene en formato válido para date input
        else if (!isNaN(Date.parse(raw))) {
          fechaCorteFormatted = new Date(raw).toISOString().split('T')[0];
        }
      } catch (error) {
        console.error('Error formateando fecha:', error);
      }
    }

    const parsedVenta = {
      ...venta,
      fechaCorte: fechaCorteFormatted
    };

    setEditVentaOnlineForm(parsedVenta);
  };

  // Función para manejar cambios en el formulario de edición
  const handleEditVentaOnlineChange = (e) => {
    const { name, value } = e.target;
    setEditVentaOnlineForm((prev) => ({ ...prev, [name]: value }));
  };

  // Función para guardar cambios en venta online
  const handleEditVentaOnlineSave = async () => {
    const confirmed = window.confirm('¿Estás seguro de que deseas realizar los cambios?');
    if (!confirmed) {
      return; 
    }
    
    try {
      // Formatear fechaCorte de vuelta a DD/MM/YYYY antes de guardar
      const dataToSave = { ...editVentaOnlineForm };
      
      if (dataToSave.fechaCorte) {
        try {
          // Convertir de YYYY-MM-DD a DD/MM/YYYY
          const [year, month, day] = dataToSave.fechaCorte.split('-');
          dataToSave.fechaCorte = `${day}/${month}/${year}`;
        } catch (error) {
          console.error('Error formateando fecha para guardar:', error);
        }
      }

      // Actualizar en la colección ventasOnline
      const ventaOnlineDocRef = doc(db, 'ventasOnline', editingVentaOnline.id);
      console.log('Guardando venta online:', dataToSave);

      // Solo actualizar la fecha de corte
      const updateData = {
        fechaCorte: dataToSave.fechaCorte
      };

      await updateDoc(ventaOnlineDocRef, updateData);

      alert('Venta online actualizada correctamente');
      setEditingVentaOnline(null);

      // Refrescar los datos
      const codigos = results.map(r => r.codigo);
      const ventasOnlineData = await fetchVentasOnline(codigos);
      setVentasOnline(ventasOnlineData);
      
    } catch (error) {
      console.error('Error actualizando la venta online:', error);
      alert('Ocurrió un error al actualizar la venta online. Por favor, inténtalo de nuevo.');
    }
  };

  const handleEditVentaClick = (venta) => {
    console.log('Raw endDate from venta:', venta.endDate);
    setEditingVenta(venta);

    let endDateFormatted = '';
    if (venta.endDate) {
      const raw = venta.endDate;

      if (!isNaN(Date.parse(raw))) {
        endDateFormatted = new Date(raw).toISOString().split('T')[0];
      }
      else if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(raw)) {
        const [day, month, year] = raw.split('/');
        const parsed = new Date(`${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`);
        endDateFormatted = parsed.toISOString().split('T')[0];
      }
    }

    const parsedVenta = {
      ...venta,
      endDate: endDateFormatted
    };

    setEditVentaForm(parsedVenta);
  };

  const handleEditVentaChange = (e) => {
    const { name, value } = e.target;
    setEditVentaForm((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    if (isLoading && loadingBearRef.current) {
      const animation = lottie.loadAnimation({
        container: loadingBearRef.current,
        animationData: loadingBear,
        renderer: 'svg',
        loop: true,
        autoplay: true,
      });
  
      return () => animation.destroy();
    }
  }, [isLoading]);
  
  const handleEditVentaSave = async () => {
    const confirmed = window.confirm('¿Estás seguro de que deseas realizar los cambios?');
    if (!confirmed) {
      return; 
    }
    try {
      // Solo actualizar en la colección Ventas
      const ventasDocRef = doc(db, 'Ventas', editingVenta.id);
      console.log('Guardando venta:', editVentaForm);
      
      const dataToUpdate = {
        phoneNumber: editVentaForm.phoneNumber,
        endDate: editVentaForm.endDate
      };
      
      await updateDoc(ventasDocRef, dataToUpdate);

      alert('Venta actualizada correctamente');
      setEditingVenta(null);
      await handleSearch();
    } catch (error) {
      console.error('Error actualizando la venta:', error);
      alert('Ocurrió un error al actualizar la venta. Por favor, inténtalo de nuevo.');
    }
  };

  const handleEditClick = (account) => {
    setEditingAccount(account);
    setEditForm(account);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditSave = async () => {
    const confirmed = window.confirm('¿Estás seguro de que deseas realizar los cambios?');
    if (!confirmed) {
      return; 
    }
    try {
      const docRef = doc(db, 'Cuentas', editingAccount.id);
      await updateDoc(docRef, editForm);
      alert('Datos actualizados correctamente');
      setEditingAccount(null);
      await handleSearch(); 
    } catch (error) {
      console.error('Error actualizando el documento:', error);
      alert('Ocurrió un error al actualizar los datos. Por favor, inténtalo de nuevo.');
    }
  };

  const fetchVentasOnline = async (codigos) => {
    if (!codigos || codigos.length === 0) return [];
    
    try {
      setLoadingVentasOnline(true);
      const ventasOnlineRef = collection(db, 'ventasOnline');
      
      // Firestore tiene límite de 10 elementos en 'in', dividir si hay más códigos
      const chunks = [];
      for (let i = 0; i < codigos.length; i += 10) {
        chunks.push(codigos.slice(i, i + 10));
      }

      const allVentasOnline = [];
      for (const chunk of chunks) {
        const ventasOnlineQuery = query(ventasOnlineRef, where('codigo', 'in', chunk));
        const ventasOnlineSnapshot = await getDocs(ventasOnlineQuery);
        
        ventasOnlineSnapshot.forEach((doc) => {
          const data = doc.data();
          
          // Formatear fechaInicio (formato CORRECTO: DD/MM/YYYY)
          let fechaInicioFormatted = 'N/A';
          if (data.fechaInicio) {
            try {
              // Si viene como string en formato DD/MM/YYYY
              if (typeof data.fechaInicio === 'string' && /^\d{1,2}\/\d{1,2}\/\d{4}$/.test(data.fechaInicio)) {
                const [day, month, year] = data.fechaInicio.split('/');
                const date = new Date(year, month - 1, day);
                fechaInicioFormatted = date.toLocaleDateString('es-CO', { 
                  timeZone: 'America/Bogota',
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit'
                });
              }
              // Si viene como timestamp de Firebase (fallback)
              else if (data.fechaInicio.seconds) {
                fechaInicioFormatted = new Date(data.fechaInicio.seconds * 1000).toLocaleDateString('es-CO', { 
                  timeZone: 'America/Bogota' 
                });
              }
              // Si viene en otro formato de string
              else if (typeof data.fechaInicio === 'string') {
                fechaInicioFormatted = data.fechaInicio;
              }
            } catch (error) {
              console.error('Error formateando fechaInicio:', error, data.fechaInicio);
              fechaInicioFormatted = data.fechaInicio.toString();
            }
          }
          
          // Formatear fechaCorte (formato: DD/MM/YYYY)
          let fechaCorteFormatted = 'N/A';
          if (data.fechaCorte) {
            try {
              // Si viene como string en formato DD/MM/YYYY
              if (typeof data.fechaCorte === 'string' && /^\d{1,2}\/\d{1,2}\/\d{4}$/.test(data.fechaCorte)) {
                const [day, month, year] = data.fechaCorte.split('/');
                const date = new Date(year, month - 1, day);
                fechaCorteFormatted = date.toLocaleDateString('es-CO', { 
                  timeZone: 'America/Bogota',
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit'
                });
              }
              // Si viene como timestamp de Firebase (fallback)
              else if (data.fechaCorte.seconds) {
                fechaCorteFormatted = new Date(data.fechaCorte.seconds * 1000).toLocaleDateString('es-CO', { 
                  timeZone: 'America/Bogota' 
                });
              }
              // Si viene en otro formato
              else if (typeof data.fechaCorte === 'string') {
                fechaCorteFormatted = data.fechaCorte;
              }
            } catch (error) {
              console.error('Error formateando fechaCorte:', error, data.fechaCorte);
              fechaCorteFormatted = data.fechaCorte.toString();
            }
          }
          
          allVentasOnline.push({ 
            id: doc.id, 
            ...data,
            fechaInicioFormatted,
            fechaCorteFormatted
          });
        });
      }
      
      return allVentasOnline;
    } catch (error) {
      console.error('Error fetching ventas online:', error);
      return [];
    } finally {
      setLoadingVentasOnline(false);
    }
  };

  const handleCopyVentaOnline = (venta, account) => {
    const textToCopy = `
🪪 *Código*: \`${venta.codigo}\`🐻 
*Servicio*: _${venta.plataforma}_
*Correo:* ${account.correo}
*Contraseña:* ${account.contrasena}
*Perfil:* ${venta.nombrePerfil || 'N/A'} 
*PIN:* ${venta.pinPerfil || 'N/A'} 
*Comprador:* ${venta.nombreComprador || 'N/A'}
*Número:* ${venta.numero || 'N/A'}
*Fecha de Inicio:* ${venta.fechaInicioFormatted} 
*Fecha de Corte:* ${venta.fechaCorteFormatted}
*Medio de Pago:* ${venta.medioPago || 'N/A'}
*ID Transacción:* ${venta.idTransaccion || 'N/A'}
    `;

    navigator.clipboard.writeText(textToCopy)
      .then(() => alert('Datos copiados al portapapeles'))
      .catch((err) => console.error('Error al copiar al portapapeles:', err));
  };

  const handleSearch = async () => {
    if (!input.trim()) {
      alert('Por favor, ingresa un código o correo');
      return;
    }

    setIsLoading(true); 
  
    try {
      const cuentasRef = collection(db, 'Cuentas');
      const cuentasCodigoQuery = query(cuentasRef, where('codigo', '==', input));
      const cuentasCorreoQuery = query(cuentasRef, where('correo', '==', input));
  
      const [cuentasCodigoSnapshot, cuentasCorreoSnapshot] = await Promise.all([
        getDocs(cuentasCodigoQuery),
        getDocs(cuentasCorreoQuery),
      ]);
  
      const cuentas = [];
      cuentasCodigoSnapshot.forEach((doc) => cuentas.push({ id: doc.id, ...doc.data() }));
      cuentasCorreoSnapshot.forEach((doc) => {
        const cuenta = { id: doc.id, ...doc.data() };
        if (!cuentas.some((c) => c.id === cuenta.id)) {
          cuentas.push(cuenta);
        }
      });
  
      console.log('Cuentas encontradas:', cuentas);
  
      if (cuentas.length === 0) {
        setResults([]);
        setMostrarVentasOnline(false);
        setVentasOnline([]);
        return;
      }

      const ventasRef = collection(db, 'Ventas');
      const ventasSnapshot = await getDocs(query(ventasRef, where('codigo', 'in', cuentas.map((c) => c.codigo))));
  
      const ventas = [];
      ventasSnapshot.forEach((doc) => ventas.push({ id: doc.id, ...doc.data() }));
  
      console.log('Ventas encontradas:', ventas);

      const combinedResults = cuentas.map((cuenta) => {
        const relatedVentas = ventas.filter((venta) => venta.codigo === cuenta.codigo);

        const formattedVentas = relatedVentas.map((venta) => {
          const date = venta.endDate ? new Date(venta.endDate) : null;
          const formattedDate = date
            ? date.toLocaleDateString('es-CO', { timeZone: 'America/Bogota' })
            : 'Fecha no disponible';
          return { 
            ...venta, 
            EnDate: formattedDate,
            perfil: venta.perfil || venta.profile || 'N/A',
            pin: venta.pin || 'N/A'
          };
        });

        return { ...cuenta, ventas: formattedVentas };
      });
  
      console.log('Resultados combinados:', combinedResults);
      setResults(combinedResults);

      // Buscar ventas online para los códigos encontrados
      const codigos = cuentas.map(c => c.codigo);
      const ventasOnlineData = await fetchVentasOnline(codigos);
      setVentasOnline(ventasOnlineData);
      setMostrarVentasOnline(true);
      
    } catch (error) {
      console.error('Error fetching data: ', error);
    } finally {
      setIsLoading(false); 
    }
  };
  
  const handleCopyToClipboard = (account, venta) => {
    const textToCopy = `
🪪 *Código*: \`${account.codigo}\`🐻 
*Servicio*: _${account.plataforma}_
*Celular:* ${venta.phoneNumber} 
*Correo:* ${account.correo} 
*Contraseña:* ${account.contrasena} 
*Perfil:* ${venta.perfil || venta.profile || 'N/A'} 
*PIN:* ${venta.pin || 'N/A'} 
*Fecha de Finalización:* ${venta.EnDate} 
    `;
  
    navigator.clipboard.writeText(textToCopy)
      .then(() => alert('Datos copiados al portapapeles'))
      .catch((err) => console.error('Error al copiar al portapapeles:', err));
  };

  const handleNotify = (account, venta) => {
    const phoneNumber = venta.phoneNumber;
    if (!phoneNumber) {
      alert('El número de teléfono no está disponible');
      return;
    }
  
    const message = encodeURIComponent(`
Hola 🐻, por motivos de seguridad, hemos cambiado la contraseña de tu cuenta de streaming. Las nuevas credenciales son: 

🪪 *Código*: \`${account.codigo}\` 🐻 
*Servicio*: _${account.plataforma}_ 
*Celular:* ${venta.phoneNumber} 
*Correo:* ${account.correo} 
*Contraseña:* ${account.contrasena} 
*Perfil:* ${venta.perfil || venta.profile || 'N/A'} 
*PIN:* ${venta.pin || 'N/A'} 
*Fecha de Finalización:* ${venta.EnDate} 

Si tienes alguna duda, avísame
    `);
  
    const url = `https://api.whatsapp.com/send?phone=+57${phoneNumber}&text=${message}`;
    window.open(url, '_blank');
  };
  
  const handleBack = () => {
    navigate('/home');  
  };
  
  const backgroundStyle = {
    minHeight: '100vh',
    width: '100%',
    margin: 0,
    padding: 0,
    backgroundImage: `linear-gradient(
        rgba(0, 0, 0, 0.58), 
        rgba(0, 0, 0, 0.75)
    ), url(${backgroundImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed',
    backgroundRepeat: 'no-repeat',
    position: 'relative',
    overflowX: 'hidden' 
  };

  return (
    <>
      {isLoading && (
        <div className="loading-overlay">
          <div className="loading-animation" ref={loadingBearRef}></div>
          <p className="loading-text">Buscando cuenta... 🐻</p>
        </div>
      )}

      <div style={backgroundStyle}>
        <div className="suscriptions-accounts-container">
          <h2 className={styles['title']}>Búsqueda y modificación de cuentas y suscripciones</h2>
          <div className={styles['form-group']}>
            <input
              type="text"
              placeholder="Ingresa código o correo"
              value={input}
              onChange={(e) => setInput(e.target.value)}
            />
            <button onClick={handleSearch} className={`${styles.searchButton}`}>Buscar</button>
          </div>
          <div>
            {results.length > 0 ? (
              results.map((result, index) => (
                <div key={index}>
                  <h3>Información de la cuenta</h3>
                  <table className={styles['accounts-table']}>
                    <thead>
                      <tr>
                        <th>Código</th>
                        <th>Correo</th>
                        <th>Contraseña</th>
                        <th>Fecha de Corte</th>
                        <th>País</th>
                        <th>Pantallas</th>
                        <th>Propietario</th>
                        <th>Tarjeta</th>
                        <th>Plataforma</th>
                        <th>Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{result.codigo}</td>
                        <td>{result.correo}</td>
                        <td>{result.contrasena}</td>
                        <td>{result.fechaCorte}</td>
                        <td>{result.pais}</td>
                        <td>{result.pantallas}</td>
                        <td>{result.propietario}</td>
                        <td>{result.tarjeta}</td>
                        <td>{result.plataforma}</td>
                        <td>
                          <div className={styles['action-buttons']}>
                            <button onClick={() => handleEditClick(result)} className={styles['action-button']}>Modificar</button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  {/* Formulario de edición para la cuenta */}
                  {editingAccount && editingAccount.id === result.id && (
                    <div className={styles['edit-form']}>
                      <h4>Editar Cuenta</h4>
                      <form>
                        <label>Correo:</label>
                        <input
                          type="email"
                          name="correo"
                          value={editForm.correo || ''}
                          onChange={handleEditChange}
                        />
                        <label>Contraseña:</label>
                        <input
                          type="text"
                          name="contrasena"
                          value={editForm.contrasena || ''}
                          onChange={handleEditChange}
                        />
                        <label>Fecha de Corte:</label>
                        <input
                          type="date"
                          name="fechaCorte"
                          value={editForm.fechaCorte || ''}
                          onChange={handleEditChange}
                        />
                        <label>País:</label>
                        <input
                          type="text"
                          name="pais"
                          value={editForm.pais || ''}
                          onChange={handleEditChange}
                        />
                        <label>Propietario:</label>
                        <input
                          type="text"
                          name="propietario"
                          value={editForm.propietario || ''}
                          onChange={handleEditChange}
                        />
                        <label>Tarjeta:</label>
                        <input
                          type="text"
                          name="tarjeta"
                          value={editForm.tarjeta || ''}
                          onChange={handleEditChange}
                        />
                      </form>
                      <button type="button" onClick={handleEditSave} className={`${styles.searchButton}`}>
                        Guardar Cambios
                      </button>
                      <button
                        type="button"
                        onClick={() => setEditingAccount(null)} className={styles['transparentFullButton']}
                      >
                        Cancelar
                      </button>
                    </div>
                  )}

                  {/* Tabla 2: Ventas Asociadas */}
                  <h3>Suscripciones asociadas</h3>
                  <table className={styles['accounts-table']}>
                    <thead>
                      <tr>
                        <th>Código</th>
                        <th>Celular</th>
                        <th>PIN</th>
                        <th>Perfil</th>
                        <th>Cantidad</th>
                        <th>Fecha de Finalización</th>
                        <th>Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {result.ventas.map((venta, i) => (
                        <tr key={i}>
                          <td>{venta.codigo}</td>
                          <td>{venta.phoneNumber}</td>
                          <td>{venta.pin || 'N/A'}</td>
                          <td>{venta.perfil || venta.profile || 'N/A'}</td>
                          <td>{venta.quantity}</td>
                          <td>{venta.EnDate}</td>
                          <td>
                            <div className={styles['action-buttons']}>
                              <button onClick={() => handleEditVentaClick(venta)} className='btn cancel'>
                                🖊️
                              </button>
                              <button onClick={() => handleCopyToClipboard(result, venta)} className='btn cancel'>
                                📎
                              </button>
                              <button onClick={() => handleNotify(result, venta)} className='btn cancel'>
                                🔔
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  {/* Formulario de edición para la venta - SIMPLIFICADO */}
                  {editingVenta && editingVenta.id && (
                    <div className={styles['edit-form']}>
                      <h4>Editar suscripción</h4>
                      <form>
                        <label>Celular:</label>
                        <input
                          type="text"
                          name="phoneNumber"
                          value={editVentaForm.phoneNumber || ''}
                          onChange={handleEditVentaChange}
                        />
                        <label>Fecha de Finalización:</label>
                        <input
                          type="date"
                          name="endDate"
                          value={editVentaForm.endDate || ''}
                          onChange={handleEditVentaChange}
                        />
                      </form>
                      <button type="button" onClick={handleEditVentaSave} className={`${styles.searchButton}`}>
                        Guardar Cambios
                      </button>
                      <button
                        type="button"
                        onClick={() => setEditingVenta(null)}
                        className={styles['transparentFullButton']}
                      >
                        Cancelar
                      </button>
                    </div>
                  )}
                </div>
              ))
            ) : (
              <p>No se encontraron resultados</p>
            )}

        {/* Nueva sección: Tabla de Ventas Online */}
       {mostrarVentasOnline && (
  <div style={{ marginTop: '30px' }}>
    <h2>Ventas de la Tienda Online</h2>
    
    {loadingVentasOnline ? (
      <p>Cargando ventas online...</p>
    ) : ventasOnline.length > 0 ? (
      <>
        <table className={styles['accounts-table']}>
          <thead>
            <tr>
              <th>Código</th>
              <th>Plataforma</th>
              <th>Correo</th>
              <th>Perfil</th>
              <th>PIN</th>
              <th>Número</th>
              <th>Comprador</th>
              <th>Fecha Inicio</th>
              <th>Fecha Corte</th>
              <th>Medio Pago</th>
              <th>ID Transacción</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {ventasOnline.map((venta) => {
              // Encontrar la cuenta correspondiente para pasar correo y contraseña
              const cuentaAsociada = results.find(r => r.codigo === venta.codigo);
              
              return (
                <tr key={venta.id}>
                  <td>{venta.codigo}</td>
                  <td>{venta.plataforma}</td>
                  <td>{venta.correo || 'N/A'}</td>
                  <td>{venta.nombrePerfil || 'N/A'}</td>
                  <td>{venta.pinPerfil || 'N/A'}</td>
                  <td>{venta.numero || 'N/A'}</td>
                  <td>{venta.nombreComprador || 'N/A'}</td>
                  <td>{venta.fechaInicioFormatted}</td>
                  <td>{venta.fechaCorteFormatted}</td>
                  <td>{venta.medioPago || 'N/A'}</td>
                  <td style={{ fontSize: '10px', maxWidth: '100px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {venta.idTransaccion || 'N/A'}
                  </td>
                  <td>
                    <div className={styles['action-buttons']}>
                      <button 
                        onClick={() => handleEditVentaOnlineClick(venta)} 
                        className='btn cancel'
                        title="Modificar"
                      >
                        🖊️
                      </button>
                      <button 
                        onClick={() => handleCopyVentaOnline(venta, cuentaAsociada)} 
                        className='btn cancel'
                        title="Copiar información"
                      >
                        📎
                      </button>
                      <button 
                        onClick={() => handleNotifyVentaOnline(venta, cuentaAsociada)} 
                        className='btn cancel'
                        title="Notificar por WhatsApp"
                      >
                        🔔
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        {/* Formulario de edición para venta online - SIMPLIFICADO */}
        {editingVentaOnline && editingVentaOnline.id && (
          <div className={styles['edit-form']}>
            <h4>Editar Venta Online</h4>
            <form>
              <label>Fecha de Corte:</label>
              <input
                type="date"
                name="fechaCorte"
                value={editVentaOnlineForm.fechaCorte || ''}
                onChange={handleEditVentaOnlineChange}
              />
            </form>
            <button type="button" onClick={handleEditVentaOnlineSave} className={`${styles.searchButton}`}>
              Guardar Cambios
            </button>
            <button
              type="button"
              onClick={() => setEditingVentaOnline(null)}
              className={styles['transparentFullButton']}
            >
              Cancelar
            </button>
          </div>
        )}
      </>
    ) : (
      <p>No se encontraron ventas online para estos códigos</p>
    )}
  </div>
)}

            <div className="button-group">
              <button type="button" className={styles['transparentFullButton']} onClick={handleBack}>Regresar a Inicio 🐻</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccountSearchPage;